/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FeedbackData
 */
export interface FeedbackData {
    /**
     * 
     * @type {number}
     * @memberof FeedbackData
     */
    stars?: number;
    /**
     * 
     * @type {string}
     * @memberof FeedbackData
     */
    comment?: string;
}

export function FeedbackDataFromJSON(json: any): FeedbackData {
    return FeedbackDataFromJSONTyped(json, false);
}

export function FeedbackDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): FeedbackData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stars': !exists(json, 'stars') ? undefined : json['stars'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
    };
}

export function FeedbackDataToJSON(value?: FeedbackData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stars': value.stars,
        'comment': value.comment,
    };
}

